import React, { useContext } from 'react';
import MegawidgetCommonFacade from '../../../../facades/megawidget-specialty/megawidget-common.facade';
import AppointmentHelper from '../../../../helpers/appointment-helper';
import DateHelper, { SlotInterval } from '../../../../helpers/date-helper';
import WidgetRequest from '../../../../models/widget-request';
import config from '../../widget-config';
import noVisitsSrc from '../../../../images/no-visits-logo.png';
import { CommonContext } from '../../../../App';
import bottomImageFooterOffice from '../../../../images/m-bottom-img-service-in-the-office.png';
import bottomImageFooterOnline from '../../../../images/m-bottom-img-service-online.png';
import InputSelect from './input-select';
import DictionaryItem from '../../../../models/dictionary-item';
import { classicNameResolver } from 'typescript';

export const GetRequest = (slotInterval: number, appDate: Date, lastPossibleDate: Date, selectedRegionCode: string, selectedSpecialisationCode: string, selectedClinicCode: string): WidgetRequest => {
    const request = new WidgetRequest();
    const daysToFetch = AppointmentHelper.getDaysToFetch(lastPossibleDate, appDate);
    const now = new Date();

    request.appointmentDate = DateHelper.getDateForUrl(appDate);
    request.daysToFetch = daysToFetch;
    request.executionDate = now;
    request.expirationDate = DateHelper.addMinutes(now, 0.5);
    request.selectedRegion = selectedRegionCode;
    request.selectedSpecialisation = selectedSpecialisationCode;
    request.url = `${config.API_URL}/api/appointments?SlotInterval=${slotInterval}&RegionCode=${selectedRegionCode}&SpecialtyCode=${selectedSpecialisationCode}&PageIndex=1&PageSize=50&ClinicCode=${selectedClinicCode}&DoctorCode&AppointmentDate=${DateHelper.getDateForUrl(appDate)}&DaysToFetch=${daysToFetch}`;

    return request;
}

export const RenderMainFilters = (size: string, arrowHorizontalFirst: number, arrowHorizontalSecond: number, arrowHorizontalThird: number, arrowTopFirst: number, arrowTopSecond: number, arrowTopThird: number, selectedClinic: string, selectedSpecialisation: string) => {
    const { state, dispatch } = useContext(CommonContext);
    if (false) {
        return (
            <>
                {/* <div className={`${size}-inputSelectTop`}>
                    <InputSelect inputPlaceholder="Wybierz doktora" options={state.doctors} selectItem="SPECIALISATION" inputClass={`${size}-selectInput`} arrowLeft={arrowHorizontalFirst} arrowTop={arrowTopFirst} size={size} value={selectedSpecialisation} action1={dispatch} action2={dispatch} state={state} />
                </div> */}
                {/* <div className={`${size}-inputSelectTop`}>
                    <InputSelect inputPlaceholder="Wybierz miasto" options={state.allDicts.regions} selectItem="REGION" inputClass={`${size}-selectInput`} arrowLeft={arrowHorizontalSecond} arrowTop={arrowTopSecond} size={size} value={selectedRegion} action1={dispatch} action2={dispatch} state={state} />
                </div> */}
            </>
        )
    }
    else {
            return (
                <>
                    <div className={`${size}-inputSelectTop`} style={{ marginBottom: 5 }}>
                        <InputSelect inputPlaceholder="Wybierz specjalizację" options={state.specialities} selectItem="SPECIALISATION" inputClass={`${size}-selectInput`} arrowLeft={arrowHorizontalThird} arrowTop={arrowTopThird} value={state.selectedSpecialisationDescription} size={size} action1={dispatch} action2={dispatch} action3={dispatch} action4={dispatch} action5={dispatch} action6={dispatch} action7={dispatch} action8={dispatch} state={state} />
                    </div>
                    <div className={`${size}-inputSelectTop`}>
                        <InputSelect inputPlaceholder="Wybierz klinikę" options={state.clinics} selectItem="CLINICS" inputClass={`${size}-selectInput`} arrowLeft={arrowHorizontalThird} arrowTop={arrowTopThird} value={state.selectedClinicDescription} size={size} action1={dispatch} action2={dispatch} action3={dispatch} action4={dispatch} action5={dispatch} state={state} />
                    </div>
                </>
        )
    }
}

export const RenderSubfilters = (widgetSize: string, arrowFirstLeft: number, arrowFirstTop: number, arrowSecondLeft: number, arrowSecondTop: number, arrowThirdLeft: number, arrowThirdTop: number): React.ReactElement => {
    return (
        <>
            {RenderTimeSelect(arrowFirstLeft, arrowFirstTop, widgetSize)}
            {RenderClinicSelect(arrowSecondLeft, arrowSecondTop, widgetSize)}
            {RenderSpecialisationSelect(arrowThirdLeft, arrowThirdTop, widgetSize)}
        </>
    )
}

export const RenderTimeSelect = (arrowLeft: number, arrowTop: number, widgetSize: string) => {
    const { state, dispatch } = useContext(CommonContext);
    return (
        <>
            <span className="arrow down" style={{ position: "absolute", left: arrowLeft, top: arrowTop }}></span>
            <select defaultValue={state.slotInterval} className={`${widgetSize}-selectBottom`} onChange={(event) => MegawidgetCommonFacade.megawidgetCommonFacade.onTimeSelect(event) }>
                <option value={0}>Wybierz godziny</option>
                {
                    Object.values(SlotInterval).map((key: any, index: number) => {
                        if (isNaN(Number(key))) {
                            return;
                        }
                        return <option key={index} value={key} >{DateHelper.getSlotInterval(key)}</option>
                    })
                }
            </select>
        </>
    )
}

export const RenderClinicSelect = (arrowLeft: number, arrowTop: number, widgetSize: string) => {
    const { state, dispatch } = useContext(CommonContext);
    return (
        <>
            <span className="arrow down" style={{ position: "absolute", left: arrowLeft, top: arrowTop }}></span>
            <select defaultValue={state.selectedClinicCode} className={`${widgetSize}-selectBottom`} onChange={(event) => MegawidgetCommonFacade.megawidgetCommonFacade.onClinicSelect(event)}>
                <option value="">Wybierz placówkę</option>
                {
                    AppointmentHelper.getClinics(state.result, state.selectedDate).map((clinic: DictionaryItem, index: number) => {
                        return <option key={index} value={clinic.code}>{clinic.description}</option>
                    })
                }
            </select>
        </>
    )
}

export const RenderSpecialisationSelect = (arrowLeft: number, arrowTop: number, widgetSize: string) => {
    const { state, dispatch } = useContext(CommonContext);
    return (
        <>
            <span className="arrow down" style={{ position: "absolute", left: arrowLeft, top: arrowTop }}></span>
            <select className={`${widgetSize}-selectBottom`}>
                <option>Wybierz specjalistę</option>
                {
                    AppointmentHelper.getSpecialists(state.result, state.selectedDate).map((specialist: DictionaryItem, index: number) => {
                        return <option key={index} value={specialist.code}>{specialist.description}</option>
                    })
                }
            </select>
        </>
    )
}

export const RenderPresentedDates = (widgetSize: string, daysAmount: number): React.ReactElement => {
    return (
        <>
            {RenderDateArrowLeft(widgetSize)}
            {RenderDates(widgetSize)}
            {RenderDateArrowRight(widgetSize, daysAmount)}
        </>
    )
}

export const RenderDateArrowLeft = (widgetSize: string) => {
    const { state, dispatch } = useContext(CommonContext);
    let className = `${widgetSize}-dateChoiceArrowLeft`;
    if(state.currentPresentedDateIndex === 0) {
        className += " disabled"
    }
    return (
        <div className={className} onClick={() => MegawidgetCommonFacade.megawidgetCommonFacade.setNewPresentedDates(-1)}>
            <span>&#10094;</span>
        </div>
    )
}

export const RenderDates = (widgetSize: string) => {
    const { state, dispatch } = useContext(CommonContext);
    var presentedDates = state.availableDays.map((x: {date: Date; hours: []}) => x.date);
    if (presentedDates != null && presentedDates.length > 0 && state.currentPresentedDateIndex != null) {
        return (
            <div key={state.currentPresentedDateIndex} className={`${widgetSize}-dateElement`}>
                <span className={`${widgetSize}-visitDate`}>{DateHelper.getDateLong(new Date(presentedDates[state.currentPresentedDateIndex]))}</span>
                <span className={`${widgetSize}-dayOfTheWeek`}> {DateHelper.getDayOfTheWeekLong(new Date(presentedDates[state.currentPresentedDateIndex]))}</span>
                {/* <div className={`${widgetSize}-visitsNumber`}><span>{AppointmentHelper.getAppointmentsCount(state.result, date)} wizyt</span></div> */}
            </div>
        )
    }
    // return presentedDates.map((date: Date, index: number) => { // presented dates
    //     return (
    //         <div key={index} className={DateHelper.areDatesEqual(date, state.selectedDate) ? `${widgetSize}-dateElement active` : `${widgetSize}-dateElement`} onClick={() => MegawidgetCommonFacade.megawidgetCommonFacade.setSelectedDate(date, false)}>
    //             <div className={`${widgetSize}-visitDate`}>{DateHelper.getDateLong(date)}</div>
    //             <div className={`${widgetSize}-dayOfTheWeek`}>{DateHelper.getDayOfTheWeekLong(date)}</div>
    //             {/* <div className={`${widgetSize}-visitsNumber`}><span>{AppointmentHelper.getAppointmentsCount(state.result, date)} wizyt</span></div> */}
    //         </div>
    //     )
    // })
}
export const RenderDateArrowRight = (widgetSize: string, daysAmount: number) => {
    const { state, dispatch } = useContext(CommonContext);
    let className = `${widgetSize}-dateChoiceArrowRight`;
    if((state.currentPresentedDateIndex + 1) >= state.availableDays.length) {
        className += " disabled"
    }
    return (
        <div className={className} onClick={() => MegawidgetCommonFacade.megawidgetCommonFacade.setNewPresentedDates(1)}>
            <span>&#10095;</span>
        </div>
    )
}

export const RenderNoVisit = (size: string): React.ReactElement => {
    const { state, dispatch } = useContext(CommonContext);
    if (AppointmentHelper.areNoAppointmentsInResult(state.result, state.selectedRegionCode, state.selectedSpecialisationCode, state.serviceInOffice) && state.serviceInOffice) {
        return (
            <div className={`${size}-noVisitsContainer`}>
                <img src={noVisitsSrc} />
                <span className={`${size}-noVisitsText`}>Brak dostępnych wizyt <br /> na najbliższe {state.nextPossibleDays} dni</span>
            </div>
        )
    }
    return <></>;
}

export const RenderBottomImage = (size: string): React.ReactElement => {
    const { state, dispatch } = useContext(CommonContext);
    if (state.selectedRegionDescription.length === 0 || state.selectedSpecialisationDescription.length === 0) {
        return <img src={state.serviceInOffice ? bottomImageFooterOffice : bottomImageFooterOnline} className={`${size}-bottomImg`} />
    }
    return <></>;
}